// Re-export individual classes for pattern: import { AckResponse } from "@stanterprise/protobuf/testsystem/v1/observer"
import { testsystem as observerNS } from '../../../lib/testsystem/v1/observer/observer';

// Export classes
export type AckResponse = observerNS.v1.observer.AckResponse;
export const AckResponse = observerNS.v1.observer.AckResponse;

export type TestEventCollectorClient = observerNS.v1.observer.TestEventCollectorClient;
export const TestEventCollectorClient = observerNS.v1.observer.TestEventCollectorClient;
